import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

/** Help is a page. The employee shell owns its navigation and browser history. */
@Injectable({ providedIn: 'root' })
export class HelpUiService {
  private readonly router = inject(Router);
  async open(): Promise<void> {
    await this.router.navigateByUrl(
      this.router.url.startsWith('/preview/') ? '/preview/help' : '/help',
    );
  }
}
